"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBase64DecodedSizeInBytes = exports.isEmailAttachmentTooLarge = exports.convertBytesToMb = void 0;
const storage_1 = require("../constants/storage");
const BYTES_IN_ONE_MB = 1024 * 1024;
const convertBytesToMb = (sizeInBytes) => sizeInBytes / BYTES_IN_ONE_MB;
exports.convertBytesToMb = convertBytesToMb;
const isEmailAttachmentTooLarge = (fileSizeInBytes) => (0, exports.convertBytesToMb)(fileSizeInBytes) > storage_1.MAX_EMAIL_ATTACHMENT_FILE_SIZE_MB;
exports.isEmailAttachmentTooLarge = isEmailAttachmentTooLarge;
const getBase64DecodedSizeInBytes = (base64Content) => {
    const paddingLength = base64Content.endsWith("==") ? 2 : base64Content.endsWith("=") ? 1 : 0;
    return Math.max(Math.floor((base64Content.length * 3) / 4) - paddingLength, 0);
};
exports.getBase64DecodedSizeInBytes = getBase64DecodedSizeInBytes;
